import { render, staticRenderFns } from "./listCategories.vue?vue&type=template&id=bd55b90e&scoped=true&"
import script from "./listCategories.vue?vue&type=script&lang=js&"
export * from "./listCategories.vue?vue&type=script&lang=js&"
import style0 from "./listCategories.vue?vue&type=style&index=0&id=bd55b90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd55b90e",
  null
  
)

export default component.exports